document.body.addEventListener("click", function (event) {
  const quickBtn = event.target.closest(
    ".mobile-icon_quick_add, .mobile_icon_quick_add, [data-quick-add-mobile]"
  );
  if (!quickBtn) return;

  // Prevent double-taps while waiting for swatch/quickadd HTML to refresh
  if (quickBtn.dataset.qaBusy === "1") return;
  quickBtn.dataset.qaBusy = "1";

  const mainWrapper =
    quickBtn.closest(".main_quick_add_wraper") || quickBtn.closest(".card-wrapper");
  const productCard = quickBtn.closest(".grid__item") || mainWrapper;

  const getDesiredHandle = () => {
    if (!productCard) return "";

    const href =
      productCard.querySelector(".main-product-link")?.getAttribute("href") ||
      productCard.querySelector(".card-product-link")?.getAttribute("href") ||
      "";

    const activeSwatch =
      productCard.querySelector(".color_product_main.active_color") ||
      productCard.querySelector(".color_product_main");

    const pLink = activeSwatch?.getAttribute("p-link") || href || "";
    if (!pLink) return "";

    // supports relative or absolute URLs
    return pLink.replace(/^.*\/products\//, "").split("?")[0].split("#")[0].replace(/^\/+/, "").trim();
  };

  const getSwatchImg = () => {
    if (!productCard) return "";

    const activeSwatch = productCard.querySelector(
      ".color_product_main.active_color"
    );
    const swatchImg = activeSwatch?.getAttribute("p-img");
    if (swatchImg) return swatchImg;

    const mainImg = productCard.querySelector("img.main_p_img");
    return mainImg?.currentSrc || mainImg?.getAttribute("src") || "";
  };

  const needsRefresh = (selfData) => {
    const handle = getDesiredHandle();
    if (!handle || !selfData) return false;

    const match =
      selfData.querySelector(".variants_main_wraper")?.getAttribute("data-match") ||
      selfData.getAttribute?.("data-match") ||
      "";

    if (!match) return false;

    // data-match is like: <section-id>-<handle>. We just ensure it contains the current handle.
    return !(match.endsWith("-" + handle) || match.includes(handle));
  };

  const getSelfData = () =>
    mainWrapper?.querySelector(".card_varinats_width_quick_add") ||
    mainWrapper?.querySelector(".variants_main_wraper");

  const waitForQuickAddReady = () => {
    if (!productCard) return Promise.resolve();

    const selfDataNow = getSelfData();
    const pending = productCard.dataset?.quickaddPending === "1";
    const promise = productCard._quickAddFetchPromise;

    // If we have a promise for the current card update, await it whenever we know we're not ready yet.
    if (
      promise &&
      typeof promise.then === "function" &&
      (pending || needsRefresh(selfDataNow))
    ) {
      return promise.catch(() => {});
    }

    // Already good to go
    if (!pending && !needsRefresh(selfDataNow)) return Promise.resolve();

    // Wait for the quickadd HTML to be refreshed (event-driven + polling safety-net)
    return new Promise((resolve) => {
      let done = false;

      const finish = () => {
        if (done) return;
        done = true;
        cleanup();
        resolve();
      };

      const onReady = () => {
        const selfData = getSelfData();
        const stillPending = productCard.dataset?.quickaddPending === "1";
        if (!stillPending && !needsRefresh(selfData)) finish();
      };

      const cleanup = () => {
        productCard.removeEventListener("quickadd:ready", onReady, true);
        clearInterval(interval);
        clearTimeout(timer);
      };

      productCard.addEventListener("quickadd:ready", onReady, true);

      const start = Date.now();
      const maxWait = 2000;

      const interval = setInterval(() => {
        const selfData = getSelfData();
        const stillPending = productCard.dataset?.quickaddPending === "1";
        if (!stillPending && !needsRefresh(selfData)) {
          finish();
          return;
        }
        // If for some reason pending got stuck, don't hang forever.
        if (Date.now() - start > maxWait) finish();
      }, 60);

      const timer = setTimeout(finish, maxWait);
    });
  };

  waitForQuickAddReady()
    .then(() => {
      const selfData = getSelfData();
      const mainMobilePopup = document.querySelector(".main_quick_add_data_wraper");
      const popupOverlay = document.querySelector(".quick_add_overlay");

      if (!selfData || !mainMobilePopup || !popupOverlay) {
        console.error("Required elements not found!", {
          selfData,
          mainMobilePopup,
          popupOverlay,
        });
        return;
      }

      mainMobilePopup.innerHTML = selfData.innerHTML;

      // Ensure popup image matches the currently selected swatch immediately
      const swatchImg = getSwatchImg();
      const popupImg = mainMobilePopup.querySelector(".product_img_drawer img");
      if (swatchImg && popupImg) {
        popupImg.src = swatchImg;
        popupImg.srcset = swatchImg;
      }

      mainMobilePopup.classList.add("active");
      document.body.classList.add("quick_add_open");
      popupOverlay.classList.remove("hidden");

      hideQuickAdd();
      mobilePopup();
    })
    .finally(() => {
      quickBtn.dataset.qaBusy = "0";
    });
});


//===========change model==============//

var changeModels = document.querySelectorAll('.change-model');

// var changeModel = document.querySelector('.change-model');

if (changeModels.length) {
  var changeModelsFunction = function(){
    changeModels.forEach(changeModel => {
    changeModel.addEventListener('click', function(event) {
      event.preventDefault();
      var icons = changeModel.querySelectorAll('.change-model .icon');
      // var icon = changeModel.querySelector('.change-model .icon');
      var dropdown = changeModel.nextElementSibling;
      var changeModelOverlay = changeModel.closest('.change-model-module').querySelector('.change-model-overlay');

      if(changeModelOverlay){
        changeModelOverlay.classList.toggle('hidden')
      }
      dropdown.classList.toggle('visible');
      if(window.matchMedia('(max-width: 749px)').matches){
        document.querySelector('body').classList.toggle('overflow-hidden');
      }
      
    
      // Toggle icons
      icons.forEach(icon => {
        if (icon.classList.contains('icon-chevron-up')) {
            icon.classList.remove('icon-chevron-up');
            icon.classList.add('icon-chevron-down');
            icon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-371.692 267.692-584 296-612.308l184 184 184-184L692.308-584 480-371.692Z"/></svg>'; // Chevron down SVG
        } else {
            icon.classList.remove('icon-chevron-down');
            icon.classList.add('icon-chevron-up');
            icon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m480-555.692-184 184L267.692-400 480-612.308 692.308-400 664-371.692l-184-184Z"/></svg>'; // Chevron up SVG
        }
      })
      
  });  

    var changeModelOverlayClick = changeModel.closest('.change-model-module').querySelector('.change-model-overlay');
    if(changeModelOverlayClick){
      changeModelOverlayClick.addEventListener('click', () => {
        changeModelOverlayClick.nextElementSibling.click(); 
      })
    }
    
  })
  }
  changeModelsFunction();
}

var body = document.querySelector('body');
let currentSlide = 0;
const dotsContainer = document.querySelector('.slider-dots');
const slidesContainer = document.querySelector('.product__media-list');
const allSlides = Array.from(document.querySelectorAll('.variant-change-item')); // Store slides separately

const filterSlides = (filter) => {
  // Clear the container
  slidesContainer.innerHTML = '';
  dotsContainer.innerHTML = '';

  // Filter and re-append slides based on the filter
  const filteredSlides = allSlides.filter(slide => {
    return filter === 'all' || slide.getAttribute('data-model') === filter;
  });

  filteredSlides.forEach(slide => {
    slidesContainer.appendChild(slide);
    slide.classList.remove('hidden');
  });

  const filteredMediaCount = filteredSlides.length;
  // Create new dots based on the filteredMediaCount
  for (let i = 0; i < filteredMediaCount; i++) {
    const button = document.createElement('button');
    button.className = 'slider-counter__link slider-counter__link--dots link';
    button.setAttribute('aria-label', `Load slide ${i + 1} of ${filteredMediaCount}`);
    button.setAttribute('aria-controls', `Slider-${i + 1}`);

    if (i === currentSlide) {
      button.classList.add('active');
      button.setAttribute('aria-current', 'true');
    }

    const span = document.createElement('span');
    if (filteredSlides[i].classList.contains('video-slide')) {
      span.classList = 'dot video-dot';
      span.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-play" fill="none" viewBox="0 0 12 14"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.48177 0.814643C0.81532 0.448245 0 0.930414 0 1.69094V12.2081C0 12.991 0.858787 13.4702 1.52503 13.0592L10.5398 7.49813C11.1918 7.09588 11.1679 6.13985 10.4965 5.77075L1.48177 0.814643Z" fill="currentColor"/></svg>';
    } else {
      span.classList = 'dot';
    }

    button.appendChild(span);

    function showSlide(index) {
      var TargetElement = document.querySelector('[data-loop-index="' + index + '"]');
      var TargetElementList = document.querySelector('.product__media-list');
      var ScrollWidth = TargetElement.scrollWidth * index;
      TargetElementList.scrollLeft = ScrollWidth;
    }

    button.addEventListener('click', () => showSlide(i));
    dotsContainer.appendChild(button);
  }

  // updateDots(filteredSlides);

  var icons = document.querySelectorAll('.change-model .icon');
  icons.forEach(icon => {
    icon.classList.remove('icon-chevron-up');
    icon.classList.add('icon-chevron-down');
    icon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-371.692 267.692-584 296-612.308l184 184 184-184L692.308-584 480-371.692Z"/></svg>';
  });
};
// display model images for selected variant
var mediaImages = document.querySelectorAll('.media-gallery-item');
var models = document.querySelectorAll('.model-row');

var modelRowFunction = function() {
  if (!models.length) {
    return;
  }

  models.forEach(model => {
    model.addEventListener('click', function() {
      var closeOverlay = model.closest('.change-model-module').querySelector('.change-model-overlay');

      if (window.matchMedia('(max-width: 989px)').matches) {
        body.classList.remove('overflow-hidden');
        if (closeOverlay) {
          closeOverlay.classList.add('hidden');
        }
      }

      var selectedModelValue = model.getAttribute('data-model');
      var selectedModelText = model.querySelector('[data-model-button]').textContent;

      var changeModelButtons = document.querySelectorAll('.change-model-btn-text');
      changeModelButtons.forEach(changeModelButton => {
        changeModelButton.textContent = selectedModelText;
      });

      models.forEach(siblingModel => {
        siblingModel.classList.remove('active-model');
      });

      var sameModelRows = document.querySelectorAll('.model-row[data-model="' + selectedModelValue + '"]');
      if (sameModelRows) {
        setTimeout(function() {
          sameModelRows.forEach(sameModelRow => {
            sameModelRow.classList.add('active-model');
          });
        }, 500);
      }

      setTimeout(function() {
        model.classList.add('active-model');
      }, 100);

      const filter = model.getAttribute('data-model');
      filterSlides(filter);

      if (mediaImages && mediaImages.length) {
        mediaImages.forEach(mediaImage => {
          mediaImage.classList.add('hidden');
        });
      }

      var modelDropdowns = document.querySelectorAll('.dropdown-content');
      var chevronIcons = document.querySelectorAll('.change-model-chevron');

      if (modelDropdowns) {
        modelDropdowns.forEach(modelDropdown => {
          modelDropdown.classList.remove('visible');

          chevronIcons.forEach(icon => {
            if (icon.classList.contains('icon-chevron-up')) {
              icon.classList.remove('icon-chevron-up');
              icon.classList.add('icon-chevron-down');
              icon.innerHTML =
                '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">' +
                '<path d="M480-371.692 267.692-584 296-612.308 480-428.308 664-612.308 692.308-584 480-371.692Z"/>' +
                '</svg>';
            } else {
              icon.classList.remove('icon-chevron-down');
              icon.classList.add('icon-chevron-up');
              icon.innerHTML =
                '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">' +
                '<path d="m480-555.692-184 184L267.692-400 480-612.308 692.308-400 664-371.692l-184-184Z"/>' +
                '</svg>';
            }
          });
        });
      }
    });
  });
};

modelRowFunction();

var mobileChangeModelContainer = document.querySelector('.change-model-module.large-up-hide.medium-hide');
if(mobileChangeModelContainer){
  var mobileChangeModelDropDown = mobileChangeModelContainer.querySelector('.dropdown-content');

  body.addEventListener('click', (event) => {
    if(window.matchMedia('(max-width: 749px)').matches && mobileChangeModelDropDown.classList.contains('visible') && body.classList.contains('overflow-hidden') && event.target !== mobileChangeModelContainer.querySelector('.change-model')){
        mobileChangeModelContainer.querySelector('.change-model').click();
        body.classList.remove('overflow-hidden')
    }
  })
}
  
var variantOptionsContainer = document.querySelector('.size-options');
if(variantOptionsContainer){
  var variantOptions = variantOptionsContainer.querySelectorAll('label');
  if(variantOptions){
    variantOptions.forEach(variantOption => {
      variantOption.addEventListener('click',function(){
        if(mediaImages){
          mediaImages.forEach(mediaImage => {
          mediaImage.classList.remove('hidden')
          });
        }
      });
    });
  }
}

var metaVideos = document.querySelectorAll('.video-slide');

if (metaVideos) {
  metaVideos.forEach(metaVideo => {
    metaVideo.addEventListener('click', (e) => {
      var video = metaVideo.querySelector('video');
      var vimeoIframe = metaVideo.querySelector('iframe.vimeo-iframe');

      if (!video && vimeoIframe) {
        if (!(window.Vimeo && Vimeo.Player)) return;

        const pausedBtn = metaVideo.querySelector('.paused-video-play-button');

        if (!vimeoIframe._vimeoPlayer) {
          vimeoIframe._vimeoPlayer = new Vimeo.Player(vimeoIframe);

          vimeoIframe._vimeoPlayer.on('play', function () {
            if (pausedBtn) pausedBtn.classList.add('hidden');
          });

          vimeoIframe._vimeoPlayer.on('pause', function () {
            if (pausedBtn) pausedBtn.classList.remove('hidden');
          });
        }

        vimeoIframe._vimeoPlayer.getPaused().then(function (paused) {
          if (paused) vimeoIframe._vimeoPlayer.play();
          else vimeoIframe._vimeoPlayer.pause();
        }).catch(function(){});

        return;
      }

      if (!video) return;

      if (!video.paused && !video.ended) {
        video.pause();
      } else {
        video.play();
        metaVideo.querySelector('.paused-video-play-button').classList.add('hidden');
      }

      if (video.dataset.qaVideoListenersBound === "1") return; // audit M3 — the play/pause action above runs on every click; the listeners below bind once per video element (a fresh element after 'ended' re-binds naturally)
      video.dataset.qaVideoListenersBound = "1";

      video.addEventListener('ended', () => {
        video.closest('deferred-media').removeAttribute('loaded');
        video.closest('deferred-media').querySelector('template').nextElementSibling.remove();
        metaVideo.querySelector('.paused-video-play-button').classList.add('hidden');
      });

      var playButton = metaVideo.querySelector('.deferred-media__poster-button');

      video.addEventListener('pause', () => {
        pausedTime = video.currentTime;
        metaVideo.querySelector('.paused-video-play-button').classList.remove('hidden');
      });

      video.addEventListener('play', () => {
        metaVideo.querySelector('.paused-video-play-button').classList.add('hidden');
      });

      video.addEventListener('playing', () => {
        metaVideo.querySelector('.paused-video-play-button').classList.add('hidden');
      });

      let pausedTime = 0;

      playButton.addEventListener('click', (e) => {
        video.currentTime = pausedTime;
        video.play();
      });
    });
  });
}

var mediaGallery = document.querySelector('media-gallery');
if(mediaGallery){
  var getZoomType = mediaGallery.getAttribute('data-zoom-type');
}

var metafieldModelSlides = document.querySelectorAll('.metafield-model-slide');
if(metafieldModelSlides){
  metafieldModelSlides.forEach(metafieldModelSlide => {
    metafieldModelSlide.addEventListener('click', function(){
      if(getZoomType == 'lightbox'){
        var productZoomModal = document.querySelector('.product-media-modal__content media-gallery');
        var metafieldZoomImage = metafieldModelSlide.querySelector('.global-media-settings--no-shadow');
        if(productZoomModal && metafieldZoomImage){
          productZoomModal.insertBefore(metafieldZoomImage, productZoomModal.firstChild);
          var pzSlider = productZoomModal.querySelector('slider-component');
          if (pzSlider) pzSlider.classList.add('hidden'); // audit console-cleanup — guard target elements; modal gallery is absent in current markup
        }
        
      }
    })
  })
}